module.exports = __webpack_public_path__ + "fdbe93cd71c69a117428af1a3d3e9a7e.svg";